import { render, staticRenderFns } from "./InboxDetailMenu.vue?vue&type=template&id=baeeb530&"
import script from "./InboxDetailMenu.vue?vue&type=script&lang=js&"
export * from "./InboxDetailMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports